'use client';

import React, { FC } from 'react';

import LandingImage from '../LandingImage';

import { ImageWrapper, YoutubeIframe } from './styles';
import { MediaElementProps } from './types';
import { VideoPlayer } from './VideoPlayer';

const youtubeEmbedUrl = 'https://www.youtube.com/embed/';

// MediaSource in strapi
export const MediaElement: FC<MediaElementProps> = (props) => {
  if ('image' in props) {
    return (
      <ImageWrapper
        aspectRatio={props.aspectRatio ?? '16/9'}
        legacyStyles={props.legacyStyles ?? true}
      >
        <LandingImage
          fill
          alt={props.image.alt ?? 'Image'}
          provider={props.image.provider}
          src={props.image.url}
          style={{ objectFit: props.objectFit ?? 'cover' }}
        />
      </ImageWrapper>
    );
  }

  if ('youtubeEmbedId' in props) {
    return (
      <YoutubeIframe
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        src={`${youtubeEmbedUrl}${props.youtubeEmbedId}`}
        title="Embedded youtube"
      />
    );
  }

  if ('video' in props) {
    return <VideoPlayer controls={props.controls} src={props.video} />;
  }

  return null;
};
